<template>
    <div class="position-relative">
        <router-link :to="this.link" class="text-decoration-none map-link-display">
            <InfoDisplay class="position-absolute top-0 end-0 m-2 map-link-icon" :icon="'link'" :color="'blue'" />
            <img v-bind:src="require(`@/assets/drivemap.png`)"
                class="rounded border border-info m-0 float-end map-link-image" />
        </router-link>
    </div>
</template>

<script>
import InfoDisplay from '@/components/display/InfoDisplay.vue'

export default {
    props: ['link'],
    components: {
        InfoDisplay
    }
}
</script>


<style scoped>
.map-link-display {
    display: inline-block;
    position: relative;
    border-radius: 0.375rem;
}

.map-link-image {
    transition: box-shadow 0.15s ease, border-color 0.15s ease, filter 0.15s ease;
}

.map-link-icon {
    transition: transform 0.15s ease, opacity 0.15s ease;
    opacity: 0.9;
}

.map-link-display:hover .map-link-image {
    box-shadow: 0 4px 12px rgba(13, 110, 253, 0.16);
    border-color: #0d6efd !important;
}

.map-link-display:hover .map-link-icon {
    transform: scale(1.1);
    opacity: 1;
}
</style>